/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipOverrideRequestSchema = z.object({
  commitment: z.number().min(0).max(1),
});
